export default __webpack_public_path__ + "static/media/arrow-up.138ba189.svg";